import DeviceSdk from "./deviceSdk";

/* LocalStorage keys
  ================================================================== */
const LocalStorageKeys = {
  lastActiveRadiostation: "LAST_ACTIVE_RADIOSTATION",
};

let deviceInfo = {};

/* Device Details
  ================================================================== */
export async function setDeviceInfo() {
  await DeviceSdk.initSdk();
  return new Promise((resolve, reject) => {
    Promise.all([
      DeviceSdk.platform(),
      DeviceSdk.ip(),
      DeviceSdk.locale(),
      DeviceSdk.city(),
      DeviceSdk.countryCode(),
      DeviceSdk.householdId(),
      DeviceSdk.mac(),
      DeviceSdk.uid(),
    ])
      .then(deviceDetails => {
        const deviceId = DeviceSdk.generateDeviceId({
          householdId: deviceDetails[5],
          uid: deviceDetails[7],
        });
        deviceInfo = {
          platform: "lightning",
          metadata: {
            ip: deviceDetails[1],
            locale: deviceDetails[2],
            city: deviceDetails[3],
            country: deviceDetails[4].toLowerCase(),
            householdId: deviceDetails[5],
            mac: deviceDetails[6],
            operator: "ziggo",
            deviceId,
          },
        };
        resolve();
      })
      .catch(error => {
        reject();
      });
  });
}
/* Export
  ================================================================== */
export { deviceInfo, LocalStorageKeys };

export function isBetween(x, min, max) {
  return x >= min && x <= max;
}

export function capitalizeFirstLetter(string) {
  return string !== "" ? string.charAt(0).toUpperCase() + string.slice(1) : "";
}

export function arrayContainsAnotherArray(array, toMatch) {
  var arrayAsString = array.toString();
  var toMatchAsString = toMatch.toString();
  return arrayAsString.indexOf(toMatchAsString) > -1;
}

export function getFormatted2NumbersIndex(index) {
  let numberTop = index + "";
  if (numberTop.length == 1) {
    numberTop = "0" + numberTop;
  }
  return numberTop;
}

export function changeArrayForCarousel(arrayToChange, activeIndex) {
  let headOfArray = arrayToChange.slice(0, activeIndex);
  let tailOfArray = arrayToChange.slice(activeIndex, arrayToChange.length);

  return [...tailOfArray, ...headOfArray];
}

export function truncate(stringToTruncate, size) {
  return stringToTruncate.length > size
    ? stringToTruncate.slice(0, size - 1) + "…"
    : stringToTruncate;
}
